(() => {
  const script = document.currentScript;
  const assetBase = script && script.src ? script.src.replace(/\/promo-vista-addon-margin-fallback\.js(?:\?.*)?$/, "/") : "/cdn/shop/t/15/assets/";
  const prices = {
    fabric: [535, "€5.35 each", "€5,35 per stuk"],
    safety: [200, "€2.00 each", "€2,00 per stuk"],
    singleBack: [420, "€4.20 each", "€4,20 per stuk"],
    doubleBack: [770, "€7.70 each", "€7,70 per stuk"],
    wood: [750, "€7.50 each", "€7,50 per stuk"],
    woodDouble: [1085, "€10.85 each", "€10,85 per stuk"],
    woodDirector: [920, "€9.20 each", "€9,20 per stuk"]
  };
  const image = (name) => assetBase + name;
  const isDutch = () => /^nl\b/i.test(document.documentElement.lang || "") || location.pathname.indexOf("/nl/") === 0;
  const handle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  };
  const setOption = (option, config, label) => {
    const nl = isDutch();
    option.dataset.priceCents = String(config[0]);
    option.dataset.priceLabel = nl ? config[2] : config[1];
    if (label) {
      option.value = label;
      option.textContent = " " + label + " (+" + option.dataset.priceLabel + ") ";
    } else {
      option.textContent = " " + option.value + " (+" + option.dataset.priceLabel + ") ";
    }
  };
  const apply = () => {
    const productHandle = handle();
    document.querySelectorAll(".promo-vista-order-configurator select[data-pv-unit-addon-select]").forEach((select) => {
      const optionName = (select.dataset.optionLabel || select.name || "").toLowerCase();
      let changed = false;
      Array.from(select.options).forEach((option) => {
        const cents = Number(option.dataset.priceCents || 0);
        if (cents <= 0) return;
        if (optionName.includes("fabric layout") || optionName.includes("doekindeling")) {
          setOption(option, prices.fabric);
          changed = true;
        } else if (optionName.includes("safety") || optionName.includes("veiligheids")) {
          setOption(option, prices.safety);
          changed = true;
        } else if (optionName.includes("backside") || optionName.includes("achterkant")) {
          const isDouble = productHandle === "custom-printed-double-beach-chair-with-logo";
          const label = isDouble
            ? (isDutch() ? "Extra achterkant-vlag 300 x 960 mm" : "Extra backside flag 300 x 960 mm")
            : (isDutch() ? "Extra achterkant-vlag 300 x 430 mm" : "Extra backside flag 300 x 430 mm");
          setOption(option, isDouble ? prices.doubleBack : prices.singleBack, label);
          option.dataset.imageUrl = image(isDouble ? "promo-vista-double-deck-chair-backside-flag.png" : "promo-vista-deck-chair-backside-flag.png");
          option.dataset.imageAlt = isDouble
            ? (isDutch() ? "Bedrukte achterkant-vlag op een dubbele strandstoel" : "Custom printed backside flag on a double beach chair")
            : (isDutch() ? "Bedrukte achterkant-vlag op een strandstoel" : "Custom printed backside flag on a beach chair");
          changed = true;
        } else if (optionName.includes("wood oil") || optionName.includes("houtolie")) {
          const config = productHandle === "custom-printed-double-beach-chair-with-logo"
            ? prices.woodDouble
            : productHandle === "custom-printed-director-chair-with-logo"
              ? prices.woodDirector
              : prices.wood;
          setOption(option, config);
          changed = true;
        }
      });
      if (changed && select.selectedOptions[0] && Number(select.selectedOptions[0].dataset.priceCents || 0) > 0) {
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
  window.addEventListener("shopify:section:load", apply);
  setTimeout(apply, 400);
  setTimeout(apply, 1400);
})();

;(() => {
  // Promo Vista wooden folding stool template fallback
  const targetHandle = "custom-printed-wooden-folding-stool-with-logo";
  const templateFilename = "promo-vista-wooden-folding-stool-artwork-template-650x260-mm.pdf";
  const handle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : "";
  };
  const templateUrl = () => {
    const src = document.currentScript && document.currentScript.src ? document.currentScript.src : "";
    if (src) return src.replace(/\/promo-vista-addon-margin-fallback\.js(?:\?.*)?$/, "/" + templateFilename);
    return "/cdn/shop/t/15/assets/" + templateFilename;
  };
  const apply = () => {
    if (handle() !== targetHandle) return;
    const url = templateUrl();
    document.querySelectorAll("[data-pv-template-link]").forEach((link) => {
      if (link.getAttribute("href") !== url) link.setAttribute("href", url);
      link.hidden = false;
    });
    document.querySelectorAll("[data-pv-template-property]").forEach((input) => {
      if (input.value !== url) input.value = url;
      if (input.getAttribute("value") !== url) input.setAttribute("value", url);
    });
  };
  const schedule = () => setTimeout(apply, 0);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", apply);
  else apply();
  document.addEventListener("input", schedule, true);
  document.addEventListener("change", schedule, true);
  document.addEventListener("click", schedule, true);
  window.addEventListener("shopify:section:load", apply);
  setTimeout(apply, 400);
  setTimeout(apply, 1400);
  setTimeout(apply, 3500);
  if (window.MutationObserver) {
    const observer = new MutationObserver(apply);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["href", "value", "hidden"]
    });
  }
})();

